export enum ReportTypeEnum {
  PROPOSALS = "proposals",
  SALES = "sales",
  MORE_INFO = "more_info",
  TICKETS = "average_ticket",
  PERCENTAGE = "percentage",
  QUANTITY = "quantity"
}

export type ReportType = {
  type: ReportTypeEnum;
  title: string;
};
